<template>
  <div id="app">
    <router-view v-if="isRouterAlive"> </router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true
    };
  }
};
</script>

<style lang="scss">
$bg: #222;
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $bg;
  width: 100%;
  height: 100%;
}
.ivu-modal {
  top: 60px;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: rgba(0,0,0,0.05);
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.3);
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/App.vue